
export const generateBankAccountDetailsUrl = (ownerType, bankAccountId, ownerId, purposeName) => {
	return `/bank-accounts/details/000${bankAccountId}`;
};
